import { openMailto } from "@/utils/mailto";
import heroImage from "@assets/images/new-connection-hero-image.svg";
import arrowRight from "@assets/icons/arrow-right-line.svg";
import barIcon from "@assets/icons/bar.svg";
import processImage from "@assets/images/laptop-frame2.png";
import safeIcon from "@assets/icons/safeIcon.svg";
import Hero from "../components/hero";
import {
  platformFee,
  processList,
  requireDocuments,
  whoCanApply,
  workSteps,
} from "../data";
import Help from "../components/help";

const heroData = {
  title: "Need a New Gas Connection?",
  description:
    "Whether you’re setting up a new home, restaurant, or commercial facility, Gaz Investment in Oil and Gas Supply L.L.C. (GAZ).",
  image: heroImage,
  buttonText: "Apply for New Connection",
  buttonOnclick: () =>
    openMailto({
      subject: "New Gas Connection Application",
      body: "Hello,\n\nI would like to apply for a new gas connection.\n\nProperty Type:\nAddress:\nContact Person:\nPhone:\nEmail:\n",
    }),
  footerText:
    "We provides safe, certified, and efficient gas connections across the UAE delivered and activated quickly by our licensed technicians",
  footerButtonText: "Talk to Our Team",
  footerButtonOnclick: () => openMailto({ subject: "New Connection Inquiry" }),
  footerIcon: <img src={safeIcon} alt="" className="w-7 h-7" />,
};

function NewConnection() {
  return (
    <div className="bg-white">
      <Hero data={heroData} />

      {/* WORK STEP SECTION */}
      <section className="py-10 md:py-20 lg:py-[120px] px-5 md:px-10 bg-[#F1F1F1]">
        <div className="w-[1368px] max-w-full mx-auto">
          <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold text-center">
            Here’s how it works in just four simple steps
          </h2>
          <div className="flex justify-center mt-3">
            <button className="flex items-center gap-2.5 p-2 text-xs md:text-base text-gis-red">
              Pay Instantly
              <img
                src={arrowRight}
                alt="arrow right icon"
                className="size-4 md:size-6"
              />
            </button>
          </div>

          <div className="mt-8 md:mt-[73px] grid md:grid-cols-2 gap-4 md:gap-6">
            {workSteps.map((data, index) => (
              <article
                key={index}
                className="p-3 md:p-6 border border-[#62636C33] bg-white rounded-[12px] md:rounded-[24px]"
              >
                <div className="grid rounded-full bg-gis-red size-8 md:size-11 place-content-center">
                  <span className="text-[14px] font-semibold text-white md:text-sm lg:text-lg">
                    0{index + 1}
                  </span>
                </div>

                <h3 className="text-[#090D2C] mt-4 md:mt-6 text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                  {data.title}
                </h3>

                <p className="mt-4 text-[14px] md:text-xs md:mt-6 lg:text-sm">
                  {data.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* WHO CAN APPLY SECTION */}
      <section className="py-10 md:py-20 lg:py-[120px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto">
          <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold text-center">
            Who Can Apply
          </h2>
          <p className="mt-3 md:mt-5 text-xs md:text-sm lg:text-lg text-[#62636C] max-w-[654px] text-center mx-auto">
            We serve residential, commercial, and industrial customers across
            the UAE.
          </p>

          <div className="grid gap-4 mt-8 md:mt-12 md:grid-cols-3 lg:gap-6">
            {whoCanApply.map((data, index) => (
              <article
                key={index}
                className="p-3 md:p-6 border border-[#62636C33] bg-white rounded-[12px] md:rounded-[24px]"
              >
                <h3 className="text-[#090D2C] text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                  {data.title}
                </h3>

                <p className="mt-4 text-[14px] md:text-xs md:mt-6 lg:text-sm">
                  {data.desc}
                </p>
              </article>
            ))}
          </div>

          <div className="w-full bg-[#F1F1F1] rounded-[12px] md:rounded-[24px] p-4 md:p-7 lg:p-10 mt-6 md:mt-12">
            <div className="flex items-center gap-2">
              <img
                src={barIcon}
                alt="bar icon"
                className="size-10 md:size-16"
              />
              <h3 className="text-[#1E1F24] text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                Required Documents
              </h3>
            </div>

            <div className="grid gap-4 mt-6 md:grid-cols-2 lg:grid-cols-3 md:gap-6">
              {requireDocuments.map((data, index) => (
                <article
                  key={index}
                  className="p-3 md:p-6 border border-[#62636C33] bg-white rounded-[12px] md:rounded-[24px]"
                >
                  <h3 className="text-[#090D2C] text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                    {data.title}
                  </h3>

                  <p className="mt-4 text-[14px] md:text-xs md:mt-6 lg:text-sm">
                    {data.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* TRANSPARENT FEE SECTION */}
      <section className="pb-16 md:pb-20 lg:pb-[120px] pt-10 px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto">
          <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold text-center">
            Transparent Fees — No Hidden Charges
          </h2>
          <p className="mt-3 text-xs md:text-sm lg:text-xl text-[#62636C] text-center mx-auto">
            All fees include 5% VAT. Deposits are fully refundable upon account
            closure and final bill settlement.
          </p>

          <div className="grid gap-4 mt-8 md:mt-16 md:grid-cols-2 xl:grid-cols-4 lg:gap-6">
            {platformFee.map((data, index) => (
              <article
                key={index}
                className="p-3 md:p-6 border border-[#62636C33] bg-white rounded-[12px] md:rounded-[24px]"
              >
                <span className="text-[14px] md:text-xs lg:text-sm mb-2">
                  {data.title}
                </span>
                <h3 className="text-[#090D2C] text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                  {data.price}
                </h3>

                <p className="mt-4 text-[14px] md:text-xs md:mt-6 lg:text-sm">
                  {data.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* QUICK AND TRANSPARENT */}
      <section className="py-10 md:py-20 lg:py-[120px] px-5 md:px-10 bg-[#F1F1F1]">
        <div className="w-[1368px] max-w-full mx-auto flex flex-col xl:flex-row gap-10">
          <div className="flex-1">
            <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold">
              Quick and Transparent Processing
            </h2>
            <p className="text-xs md:text-sm lg:text-lg text-[#62636C] mt-2 md:mt-5">
              Average total completion: 5-10 working days after document
              submission.
            </p>

            <div className="grid gap-4 mt-8 md:grid-cols-2 xl:grid-cols-1">
              {processList.map((data, index) => (
                <article
                  key={index}
                  className="p-3 md:p-6 bg-white rounded-[12px] md:rounded-[24px]"
                >
                  <h3 className="text-sm md:text-lg lg:text-xl font-semibold leading-[1.1]">
                    {data.title}
                  </h3>

                  <p className="mt-1 text-[14px] md:text-xs lg:text-sm text-[#62636C]">
                    {data.desc}
                  </p>
                  <p className="mt-1 text-[14px] md:text-xs lg:text-sm text-[#62636C]">
                    {data.duration}
                  </p>
                </article>
              ))}
            </div>
          </div>
          <div className="flex-[1.14]">
            <img src={processImage} alt="process image" />
          </div>
        </div>
      </section>

      {/*  */}
      <section className="pt-16 md:pt-20 lg:pt-[120px] px-5 md:px-10">
        <div className="w-[1368px] max-w-full mx-auto md:px-24">
          <h2 className="text-gis-dark-blue text-[26px] md:text-[40px] lg:text-[60px] font-semibold">
            Certified. Regulated. Compliant.
          </h2>
          <p className="text-xs md:text-sm lg:text-base text-[#62636C] mt-2 md:mt-5">
            GAZ is fully licensed and certified by Dubai Civil Defense and the
            Emirates Authority for Standardization and Metrology (ESMA). All
            connections are tested and commissioned in accordance with UAE Fire
            Safety Code of Practice.
          </p>
        </div>
      </section>

      <Help title="Smell Gas or Need Help?" />
    </div>
  );
}

export default NewConnection;
